import Vue from 'vue'
import Router from 'vue-router'
// webpack 2.2
// const Authorization = resolve => {
//   require.ensure([], () => resolve(require('@/views/authorization/index.vue')), 'authorization')
// }
// const result = resolve => {
//   require.ensure([], () => resolve(require('@/views/authorization/result/index.vue')), 'result')
// }
// const test = resolve => {
//   require.ensure([], () => resolve(require('@/views/authorization/test/index.vue')), 'test')
// }

// webpack > 2.4
const Authorization = () =>
  import ( /* webpackChunkName: "authorization" */ '@/views/authorization/index')
// import Authorization from '@/views/authorization/index'

const result = () =>
  import ( /* webpackChunkName: "result" */ '@/views/authorization/result/index.vue')
const test = () =>
  import ( /* webpackChunkName: "test" */ '@/views/authorization/test/index.vue')

Router.prototype.isBack = true
Router.prototype.oldPush = Router.prototype.push
Router.prototype.goBack = function() {
  this.isBack = true
  window.history.go(-1)
}

Router.prototype.push = function(param) {
  this.isBack = false
  this.oldPush(param)
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/authorization'
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: Authorization,
      redirect: '/authorization/result',
      children: [{
          path: 'result',
          name: 'result',
          component: result
        },
        {
          path: 'test',
          name: 'test',
          component: test
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js